<InactivityModal />

    <div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
      <Navbar
        @sidebar-toggle="toggleSidebar"
        class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
      </Navbar>
      <div class="bg-gray px-4 py-1 h-100">
        <div class="row h-100">

      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>
          <div class="col h-100 overflow-auto mt-2">
            <div class="card rounded-5  border-0 mt-5 card-nav-tabs">
            <div class="card-header rounded-5 card-header-primary">
          <div class="nav-tabs-navigation">
                <div class="nav-tabs-wrapper">
            <ul class="nav nav-tabs text-xxs" id="pills-billib-tab" role="tablist">
            <li class="nav-item text-sm" role="presentation">
                <button class="nav-link active" id="top_loans_tab" data-bs-toggle="pill"
                    data-bs-target="#top_loans_info" type="button" role="tab"
                    aria-controls="top_loans_info" aria-selected="true">
                    Reports
                </button>
            </li>
            <li v-if="$route.params.portal_type != 'publishing'"class="nav-item text-sm" role="presentation">
                <button class="nav-link" id="consolidation_loan_tab" data-bs-toggle="pill"
                    data-bs-target="#consolidation_loan_info" type="button" role="tab"
                    aria-controls="consolidation_loan_info" aria-selected="false">
                    Segments
                </button>
            </li>
            <li  v-if="$route.params.portal_type === 'publishing'" class="nav-item text-sm" role="presentation">
                <button class="nav-link" id="category_info_tab" data-bs-toggle="pill"
                    data-bs-target="#category_info" type="button" role="tab"
                    aria-controls="category_info" aria-selected="false">
                    Tags
                </button>
            </li>
          </ul>
            </div>
            </div>
          </div>
          <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active" id="top_loans_info" role="tabpanel">
                <div v-show="is_loading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Feed List...</p>
            </div>
            <div v-show="!is_loading">
                <div class="table-responsive">
                  <table id="report-table" class="table align-middle table-striped table-borderless mb-0">
                    <thead class="text-uppercase btn-primary text-white">
                      <tr>
                        <th class="text-xxs fw-light">No:</th>
                        <th class="text-xxs fw-light text-center">Created by</th>
                        <th class="text-xxs fw-light text-center">Description</th>
                        <th class="text-xxs fw-light text-center">Primary Tag</th>
                        <th class="text-xxs fw-light text-center">Segment</th>
                        <th class="text-xxs fw-light text-center">Portal</th>
                        <th class="text-xxs fw-light text-center">Authors</th>
                        <th class="text-xxs fw-light text-center">Tags</th>
                        <th class="text-xxs fw-light text-center">Likes</th>
                        <th class="text-xxs fw-light text-center">Comments</th>
                        <th class="text-xxs fw-light text-center text-nowrap">Date Created</th>
                        <th class="text-xxs fw-light text-center text-nowrap">Action</th>
                      </tr>
                    </thead>

                    <tbody v-if="reports && reports.length">
                      <tr v-for="(report, index) in reports" :key="report.id || index">
                        <th scope="row">{{ index + 1 }}</th>
                        
                        <td class="text-center text-xxs">
                          <div v-if="report.company">
                            <span class="fw-bold">{{ report.company.company_name }}</span><br>
                            <small class="text-muted">{{ report.company.email }}</small>
                          </div>
                          <div v-else-if="report.base_profile && report.base_profile.user">
                            <span>{{ report.base_profile.user.first_name }} {{ report.base_profile.user.last_name }}</span><br>
                            <small class="text-muted">{{ report.base_profile.user.email }}</small>
                          </div>
                        </td>

                        <td class="w-25">
                          <div class="d-inline-block text-truncate text-xxs" style="max-width: 150px;">
                            <span v-if="report.description">{{ getTextOnly(report.description) }}</span>
                            <span v-else>{{ report.name || '-' }}</span>
                          </div>
                        </td>

                        <td class="text-center">
                          <span v-if="report.primary_tag" class="text-xxs">
                            {{ report.primary_tag.name }}
                          </span>
                          <span v-else>-</span>
                        </td>

                        <td class="text-center text-xxs">
                          <span v-if="report.topic">{{ report.topic.name }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>

                        <td class="text-center text-xxs">
                          {{ report.portal.name }}
                        </td>

                        <td class="text-center text-xxs">
                          <div v-if="report.authors && report.authors.length">
                            <div v-for="author in report.authors" :key="author.id">
                              {{ author.author_name }}
                            </div>
                          </div>
                          <span v-else>-</span>
                        </td>

                        <td class="text-nowrap">
                          <span v-for="tag in report.tags" :key="tag.id" class="text-xxs me-1 mb-1">
                            {{ tag.name || tag.tag || 'tag' }},
                          </span>
                          <span v-if="!report.tags || !report.tags.length" class="text-muted">-</span>
                        </td>

                        <td class="text-center text-xxs">{{ report.total_likes }}</td>
                        <td class="text-center text-xxs">{{ report.total_comments }}</td>
                        <td class="text-nowrap text-center text-xxs">{{ report.publication_date }}</td>

                        <td class="text-nowrap text-center">
                          <button @click="view_report(report)" class="btn btn-light btn-sm rounded-3 text-success border text-xxs me-1">
                            View
                          </button>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-else>
                      <tr>
                        <td colspan="12" class="text-center text-muted py-4">No feeds yet.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>


            </div>
            </div>
              <!-- Top Loans Info -->
              <div class="tab-pane fade" id="consolidation_loan_info" role="tabpanel" aria-labelledby="top_loans_tab">
                <button v-if="topics && topics.length"class="btn btn-primary text-xs rounded-3 shadow mb-3" @click="open_create_segment">
                  <i class="bi bi-plus-lg"></i> Create Segment
                </button>
                <div v-if="topics && topics.length" class="table-responsive">
                <table class="table align-middle table-striped table-borderless mb-0">
                  <thead class="text-uppercase btn-primary text-white ">
                    <tr>
                      <th class="text-xxs fw-light text-center">No.</th>
                      <th class="text-xxs fw-light">Segment Title</th>

                      <th class="text-xxs fw-light text-center">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(topic, index) in topics" :key="topic.id" class="border-bottom text-xxs">
                      <td class="text-center">
                        <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                          {{ index + 1 }}
                        </span>
                      </td>

                      <td><div class="text-xxs">{{ topic.name }}</div></td>

                      <td class="text-center">
                        <div class="d-flex justify-content-center gap-1">
                          <route-link :to="'/create_report/' + topic.id">
                          <button @click.prevent="view_segment(topic)"
                            class="btn btn-light btn-sm rounded text-success border text-xxs"
                          >
                            View
                          </button>
                          </route-link>
                          <a 
                              href=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_report_modal"@click="edit_report(report)" class="btn btn-light btn-sm rounded-3 text-primary border text-xxs me-1">
                          Edit
                      </a>
                          <button
                            class="btn btn-light btn-sm rounded text-danger border text-xxs"
                            @click.prevent="delete_segment(topic.id)"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Empty state -->
              <div v-else class="text-center py-5">
                <i class="bi bi-book display-1 text-muted mb-3"></i>
                <p class="text-muted fs-5 mb-1">No segments yet.</p>
                <p class="text-muted text-xxs mb-3">When you create segments, they will appear here.</p>
                <button class="btn btn-primary btn-sm text-xxs" @click="open_create_segment">Create your first segment</button>
              </div>

              </div>
              <!-- Category Info -->
              <div class="tab-pane fade" id="category_info" role="tabpanel" aria-labelledby="top_loans_tab">
                <div v-if="tags.length" class="table-responsive">
                <table class="table align-middle table-striped table-borderless mb-0">
                  <thead class="text-uppercase btn-primary text-white ">
                    <tr>
                      <th class="text-xxs fw-light text-center">No.</th>
                      <th class="text-xxs fw-light">Tag Title</th>

                      <th class="text-xxs fw-light text-center">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(tag, index) in tags" :key="tag.id" class="border-bottom text-xxs">
                      <td class="text-center">
                        <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                          {{ index + 1 }}
                        </span>
                      </td>

                      <td><div class="text-xxs">{{ tag.name }}</div></td>

                      <td class="text-center">
                        <div class="d-flex justify-content-center gap-1">
                          <route-link :to="'/create_report/tag/' + tag.id">
                          <button @click.prevent="view_tag_report(tag)"
                            class="btn btn-light btn-sm rounded text-success border text-xxs"
                          >
                            View
                          </button>
                          </route-link>
                          <!-- <button
                            class="btn btn-light btn-sm rounded text-success border text-xxs"
                            @click.prevent="open_edit_segment(topic)"
                          >
                            Edit
                          </button>
                          <button
                            class="btn btn-light btn-sm rounded text-danger border text-xxs"
                            @click.prevent="delete_segment(topic.id)"
                          >
                            Delete
                          </button> -->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Empty state -->
              <div v-else class="text-center py-5">
                <i class="bi bi-book display-1 text-muted mb-3"></i>
                <p class="text-muted fs-5 mb-1">No Tags yet.</p>
                {{tags}}
                <p class="text-muted text-xxs mb-3">When you create segments, they will appear here.</p>
              
              </div>

              </div>
            </div>
          </div>
          </div>
            </div>
          </div>

        </div>
       </div>
    </div>

    <div class="modal fade" id="segment_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <p class="modal-title text-xs fw-500" id="exampleModalLabel">
                    {{ editing ? 'Edit Segment' : 'Create a Segment' }}
                  </p>
                  <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
          
                <form @submit.prevent="submitSegment">
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="topic_name" class="form-label text-xs fw-500">
                        Segment Name <span class="text-danger">*</span>
                      </label>
                      <input type="text" class="form-control rounded-5 text-xs" id="topic_name" placeholder="Enter segment name"
                        v-model="topic_name">
                      <p v-if="errors.topic_name" class="text-danger text-xs">{{ errors.topic_name }}</p>
                    </div>
                  </div>
          
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-primary text-xs rounded-5">
                      {{ editing ? 'Update' : 'Post' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
      <teleport to="body">
          <div class="modal fade" id="view_report_modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div class="modal-content" v-if="selected_report">
                <div class="modal-header bg-light">
                  <div class="d-flex flex-column">
                    <h6 class="modal-title text-primary mb-0">Report Details</h6>
                    <small class="text-xxs text-muted">Published on: {{ selected_report.publication_date }}</small>
                  </div>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                  <div class="mb-4">
                    <label class="text-xxs fw-bold text-uppercase text-primary">Description</label>
                    <div class="p-3 border rounded bg-light mt-1">
                      <div class="text-xs" v-html="selected_report.description"></div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3 mb-4">
                      <label class="text-xxs fw-bold text-uppercase text-primary">Created By</label>
                      <div class="d-flex align-items-center mt-2">
                        <div v-if="selected_report.company">
                          <p class="mb-0 fw-bold text-xs">{{ selected_report.company.company_name }}</p>
                          <small class="text-xxs text-muted">Organization ({{ selected_report.company.email }})</small>
                        </div>
                        <div v-else-if="selected_report.base_profile && selected_report.base_profile.user">
                          <p class="mb-0 fw-bold text-xs">
                            {{ selected_report.base_profile.user.first_name }} {{ selected_report.base_profile.user.last_name }}
                          </p>
                          <small class="text-xxs text-muted">User ({{ selected_report.base_profile.user.email }})</small>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 mb-4 border-start-md">
                      <label class="text-xxs fw-bold text-uppercase text-primary">Portal</label>
                      <p class="mb-0 fw-bold text-xs mt-2">{{ selected_report.portal.name }}</p>
                      <span v-if="selected_report.portal.portal_type" class="badge bg-secondary text-xxs">
                        {{ selected_report.portal.portal_type.name }}
                      </span>
                    </div>

                    <div class="col-md-3 mb-4 border-start-md" v-if="selected_report.primary_tag">
                      <label class="text-xxs fw-bold text-uppercase text-primary">Primary Tag</label>
                      <div class="mt-2">
                        <span class="badge bg-secondary text-xxs fw-normal">
                          {{ selected_report.primary_tag.name }}
                        </span>
                      </div>
                    </div>

                    <div class="col-md-3 mb-4 border-start-md" v-if="selected_report.tags && selected_report.tags.length">
                      <label class="text-xxs fw-bold text-uppercase text-primary">Tags</label>
                      <div class="mt-2 d-flex flex-wrap gap-1">
                        <span v-for="tag in selected_report.tags" :key="tag.id" class="badge bg-secondary text-white text-xxs fw-normal">
                          {{ tag.name || tag.tag }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <hr>

                  <div class="mb-4" v-if="selected_report.authors && selected_report.authors.length">
                    <label class="text-xxs fw-bold text-uppercase text-primary d-block mb-2">External Authors</label>
                    <div class="d-flex flex-wrap gap-2">
                      <div v-for="author in selected_report.authors" :key="author.id" class="border rounded px-2 py-1 bg-white shadow-sm d-flex align-items-center">
                        <span class="text-xxs fw-500">{{ author.author_name }}</span>
                        <a v-if="author.author_link" :href="author.author_link" target="_blank" class="ms-2 text-primary">
                          <i class="bi bi-box-arrow-up-right text-xxs"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="mb-4" v-if="selected_report.report_files && selected_report.report_files.length">
                    <label class="text-xxs fw-bold text-uppercase text-primary mb-2 d-block">Attachments</label>
                    <div v-for="(fileObj, index) in selected_report.report_files" :key="index" class="mb-3">
                      
                      <div class="media-container image-only mb-3 text-center" v-if="fileObj?.file?.url && (
                          fileObj.file.url.includes('.jpg') || fileObj.file.url.includes('.png') || 
                          fileObj.file.url.includes('.jpeg') || fileObj.file.url.includes('.webp'))">
                        <img :src="fileObj.file.url" alt="Report Image" class="img-fluid rounded-3 border shadow-sm" />
                        <div class="mt-2 text-center">
                          <a :href="fileObj.file.url" download class="btn btn-sm btn-primary text-xs py-1 rounded">Download Image</a>
                        </div>
                      </div>

                      <div class="media-container video-audio mb-3" v-else-if="fileObj?.file?.url && (fileObj.file.url.includes('.mp3') || fileObj.file.url.includes('.wav'))">
                        <audio controls class="w-100 rounded-3 p-1 border bg-light">
                          <source :src="fileObj.file.url" :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'" />
                        </audio>
                      </div>

                      <div v-else class="uploaded-file d-flex align-items-center justify-content-between p-2 border rounded bg-white shadow-sm">
                        <div class="d-flex align-items-center">
                          <img v-if="fileObj?.file?.url" :src="getFileIcon(fileObj.file.url)" class="file-icon small-icon" style="width: 24px;" />
                          <span class="file-name text-xxs text-break ms-2 fw-500">{{ getFileName(fileObj?.file?.url) }}</span>
                          <a :href="fileObj?.file?.url" download class="ms-3"><i class="bi bi-download fs-6 text-muted"></i></a>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="row text-center mt-3 pt-3 border-top">
                    <div class="col-6">
                      <p class="mb-0 text-xxs text-muted">Likes</p>
                      <h5 class="mb-0 text-xs">{{ selected_report.total_likes }}</h5>
                    </div>
                    <div class="col-6">
                      <p class="mb-0 text-xxs text-muted">Comments</p>
                      <h5 class="mb-0 text-xs">{{ selected_report.total_comments }}</h5>
                    </div>
                  </div>

                </div>

                <div class="modal-footer d-flex justify-content-end">
                    <button 
                    type="button" 
                    class="btn btn-primary btn-sm text-xxs me-2 rounded"
                    data-bs-toggle="modal" 
                    data-bs-target="#edit_report_modal"
                    @click="edit_report(selected_report)"
                    >
                      <i class="bx bxs-edit me-1"></i> Edit
                    </button>
                    <button 
                    type="button" 
                      class="btn btn-secondary btn-sm text-xxs me-2 rounded" @click="delete_report(selected_report.id)">
                      <i class="bx bxs-trash-alt me-1"></i> Delete
                    </button>
                    <button
                      type="button"
                      :class="[
                        'btn',
                        selected_report.is_disabled ? 'btn-primary' : 'btn-secondary',
                        'btn-sm',
                        'text-xxs',
                        'me-2',
                        'rounded'
                      ]"
                      @click="disable_report_method(selected_report.id, selected_report.is_disabled)"
                    >
                      <i :class="selected_report.is_disabled ? 'bi-eye me-1' : 'bi-eye-slash me-1'"></i>
                      {{ selected_report.is_disabled ? 'Enable' : 'Disable' }}
                    </button>
                 </div>
              </div>
            </div>
          </div>
        </teleport>

    <teleport to="body">
        <div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <h5 class="modal-title text-white" id="exampleModalLabel">Edit your Feed</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="edit_report_data">
          <div class="modal-body">

            <div class="mt-2 m-2 d-flex align-items-center flex-wrap gap-2">
            <span class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="open_edit_category_modal">Tag a category </span>
            <div class="d-flex flex-wrap gap-1">
              <span
                v-for="tag in allSelectedTags"
                :key="tag.id"
                class="btn-sm d-flex align-items-center bg-light border px-3 py-1"
              >
                {{ tag.name }}
              </span>
            </div>


             <span  class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="open_edit_author_modal">Edit Author</span>
       <div v-if="report_edit && report_edit.authors && report_edit.authors.length"
            class="d-flex flex-wrap gap-2 align-items-center">

        <span v-for="(author, index) in report_edit.authors" :key="index"
            class="btn-sm d-flex align-items-center bg-light border">
          {{ author.author_name }}
          <a v-if="author.link" :href="author.link" target="_blank"
            class="text-white ms-1 text-decoration-underline" @click.stop>
            🔗</a>
            <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove"
            @click="remove_author_method(index)"></button>

        </span>
      </div>

          </div>
            <!-- Select Topic -->
            <div v-if="topics.length > 0" class="m-2 d-flex align-items-center flex-wrap gap-2">
              <label class="form-label text-xxs fw-500">Segment (Topic)</label>
              <select class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" v-model="selected_topic"
                id="topic">
                <option value="" selected hidden>Tag a segment</option>
                <option v-for="topic in topics" :value="topic.id" :key="topic.id">
                  {{ topic.name }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center mb-3">
              <label for="toggle-comments" class="form-label mb-0 text-xs fw-500">Allow comments:</label>
              <div class="form-check form-switch comment-switch">
                <input class="form-check-input" type="checkbox" id="toggle-comments" v-model="comments_off">
              </div>
              <label class="form-check-label text-xxs" for="toggle-comments">{{ comments_off ? 'Yes' : 'No' }}</label>
            </div>

            <QuillEditor theme="snow" v-model="report_description" ref="quillReportRef" class="quill-editor"
              toolbar="full" />
              <div v-if="report_edit.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border">

                <a :href="report_edit.report_link" target="_blank" class="stretched-link text-decoration-none">
                  <img v-if="report_edit.linkPreview.image" :src="report_edit.linkPreview.image"
                    class="img-fluid rounded" />
                  <div class="fw-bold mt-2">{{ report_edit.linkPreview.title }}</div>
                  <div v-if="!report_edit.linkPreview.image" class="text-muted small">{{ report_edit.linkPreview.description
                    }}</div>
                </a>
              </div>
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start flex-wrap">
              <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                <label for="editReportFileInput"
                  class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-image-add file-upload-icon'></i> Add Feed content
                </label>
                <input type="file" ref="editReportFileInput" id="editReportFileInput" class="file-input d-none" @change="handle_file_upload" />

                <!-- Truncated File Name -->
                <div v-if="editFileName" class="file-name text-xxs text-secondary fst-italic mt-1" :title="editFileName">
                  <span class="fw-500">File name:</span> {{ editFileName }}
                </div>

                <!-- Error Message -->
                <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
              </div>

              <!-- Audio Upload -->
              <div class="file-upload my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center">
                <label for="audioInput"
                  class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-music'></i> Upload Audio
                </label>
                <input type="file" accept="audio/*" id="audioInput" class="file-input d-none"
                  @change="handleAudioUpload" />
                <div v-if="audioError" class="text-xxs text-danger fst-italic mt-1">{{ audioError }}</div>
              </div>

              <!-- Audio Recorder -->
              <div class="d-flex flex-column align-items-center my-2 flex-grow-1">
                <div class="d-flex flex-row align-items-center mb-3">
                  <button type="button"
                    class="btn btn-light text-xxs text-secondary rounded-5 mx-2 d-flex align-items-center justify-content-center"
                    @click="startRecording" v-if="!isRecording">
                    <i class='bx bx-microphone'></i> Record
                  </button>
                  <button type="button"
                    class="btn btn-danger text-xxs rounded-5 mx-2 d-flex align-items-center justify-content-center"
                    @click="stopRecording" v-if="isRecording">
                    <i class='bx bx-stop'></i> Stop
                  </button>
                </div>
                <div v-if="audio_file_name" class="text-xxs text-secondary fw-500 mb-3 audio-file">
                  <i class='bx bx-music'></i> Recorded: {{ audio_file_name }}
                </div>
              </div>
            </div>

            <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
              <div class="row g-3">
                <div v-for="(fileObj, index) in edit_documents.report_files" :key="index"
                  class="position-relative mb-3">

                  <button type="button" class="btn-close btn-close-dark btn-sm position-absolute top-0 end-0 m-2"
                aria-label="Remove"
                @click="markFileForRemoval(fileObj.id, index)">
        </button>
                  <!-- Image -->
                  <img
                    v-if="fileObj.file.url.includes('.jpg') || fileObj.file.url.includes('.png') || fileObj.file.url.includes('.jpeg')"
                    :src="fileObj.file.url" alt="Feed Image" class="img-fluid rounded-5 w-100 h-100"
                    :class="{ 'zoomed-in': isZoomed }" ref="image" />

                  <!-- Audio -->
                  <audio v-else-if="fileObj.file.url.includes('.mp3') || fileObj.file.url.includes('.wav')" controls
                    class="w-100 rounded-5">
                    <source :src="fileObj.file.url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- Video -->
                  <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)" controls class="img-fluid rounded-5 w-100">
                    <source :src="fileObj.file.url" />
                    Your browser does not support the video tag.
                  </video>

                  <!-- PDF -->
                <iframe v-else-if="fileObj.file.url.includes('.pdf')" :src="fileObj.file.url"
                  class="img-fluid rounded media_preview" frameborder="0">
                </iframe>


                  <!-- Word Document -->
                  <iframe v-else-if="fileObj.file.url.includes('.docx') || fileObj.file.url.includes('.doc')"
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.url)"
                    frameborder="0" width="100%" height="500px">
                  </iframe>

                  <!-- Excel Document -->
                  <iframe v-else-if="fileObj.file.url.includes('.xls') ||
                                      fileObj.file.url.includes('.xlsx') ||
                                      fileObj.file.url.includes('.xlsm') ||
                                      fileObj.file.url.includes('.xlsb')"
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.url)"
                    frameborder="0" width="100%" height="500px">
                  </iframe>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Update</button>
          </div>
        </form>
      </div>
    </div>
        </div>
        </teleport>

        <teleport to="body">
          <div class="modal fade" id="author_modal_edit" tabindex="-1" aria-labelledby="author_modal_edit_label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content border-0 rounded-5 shadow-sm">
                <div class="modal-header">
                  <h6 class="modal-title" id="author_modal_edit_label">Edit Authors</h6>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <!-- Inputs for editing/adding authors -->
                  <input type="text" class="form-control form-control-sm mb-2 rounded"
                    v-model="edit_author_input" placeholder="Enter author name" />

              <input type="url" class="form-control form-control-sm mb-2 rounded"
                    v-model="edit_author_link" placeholder="Enter author link (optional)" />

              <button type="button" class="btn btn-primary btn-sm mb-2 rounded"
                      @click="add_author_method">
                Add Author
              </button>

                  <!-- List of existing authors -->
                  <div v-if="edit_authors.length" class="mt-2">
                    <div class="d-flex flex-wrap justify-content-start gap-1">
                      <span v-for="(author, index) in edit_authors" :key="index" class="btn-sm d-flex align-items-center bg-light border px-3 py-1">
                        {{ author.author_name }}
                        <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove" @click="remove_author_method(index)"></button>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-primary btn-sm rounded"
                          @click="save_edit_author"
                          data-bs-dismiss="modal"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_report_modal">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </teleport>


        <teleport to="body">
          <div class="modal fade" id="category_modal_edit" tabindex="-1" aria-labelledby="category_modal_label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content border-0 rounded-5 shadow-sm">

                <div class="modal-header">
                  <h6 class="modal-title" id="category_modal_label">Select Tags for Category</h6>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">

                <!-- PRIMARY TAG -->
        <div class="mb-4">
          <label class="form-label fw-bold mb-1">Primary Tag</label>

          <div v-for="(category, index) in categories" :key="'primary-edit-'+category.id"
              v-show="index < 2 || showAllPrimary" class="col-md-12">
            <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

        <multiselect
          :model-value="primary_tags.get(category.id)"
            @update:modelValue="tag => selectPrimaryTag(category.id, tag)"
          :options="category.tags"
          :multiple="false"
          placeholder="Select primary tag"
          track-by="id"
          label="name"
          class="text-xs fw-500 mb-3"
        >
          <template #option="{ option }">
            <span class="fw-500 text-xxs">{{ option.name }}</span>
          </template>
          <template #selection="{ values }">
            <span v-if="values" class="badge bg-success">{{ values.name }}</span>
          </template>
        </multiselect>

          </div>

          <div v-if="categories.length > 2" class="mt-2">
            <button type="button" class="btn btn-link btn-sm text-decoration-none"
                    @click="showAllPrimary = !showAllPrimary">
              {{ showAllPrimary ? 'Show Less' : 'Show More' }}
            </button>
          </div>
        </div>


                  <!-- SECONDARY TAGS -->
                  <div class="mb-4">
                    <label class="form-label fw-bold mb-1">Secondary Tags</label>


                    <div v-for="(category, index) in categories" :key="'secondary-edit-'+category.id"
                        v-show="index < 2 || showAllSecondary" class="col-md-12">
                      <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

                      <multiselect
                        :model-value="selected_tags.get(category.id)"
                        @update:modelValue="updateTagSelection(category.id, $event)"
                        :options="category.tags"
                        :multiple="true"
                        :preserve-search="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder="Select tags"
                        class="text-xs fw-500 mb-3"
                        track-by="id"
                        label="name"
                      >
                        <template #option="{ option }">
                          <span class="fw-500 text-xxs">{{ option.name }}</span>
                        </template>
                        <template #selection="{ values }">
                          <span v-for="(tag, index) in values" :key="index" class="badge bg-primary me-1">
                            {{ tag.name }}
                          </span>
                        </template>
                      </multiselect>

                    </div>

                    <div v-if="categories.length > 2" class="mt-2">
                      <button type="button" class="btn btn-link btn-sm text-decoration-none"
                              @click="showAllSecondary = !showAllSecondary">
                        {{ showAllSecondary ? 'Show Less' : 'Show More' }}
                      </button>
                    </div>

                  </div>

                </div>

                <div class="text-end">
                  <button type="button" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3"
                          @click="submit_tags"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_report_modal"
                          data-bs-dismiss="modal">
                    Save
                  </button>
                </div>

              </div>
            </div>
          </div>
        </teleport>
